<div class="recaptcha-wrapper">
  @if (isLoading) {
    <div class="recaptcha-loading">
      <div class="spinner"></div>
      <span>Loading captcha...</span>
    </div>
  }
  @if (loadError) {
    <div class="recaptcha-error">
      <span>Failed to load captcha. Please refresh the page.</span>
    </div>
  }
  <div #recaptchaDiv [class.hidden]="isLoading || loadError"></div>
</div>
